import {
  Alert,
  Breadcrumb,
  Button,
  Modal,
  notification,
  Select,
  Spin,
  Table,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import LeftMenu from "../components/menu";
import TopMenu from "../components/top-menu";
import { guestsService } from "../api";
import { LoadingOutlined, SettingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import ColumnsModal from "../components/columns-modal";
import { useAppDispatch, useAppSelector } from "../redux/store/hooks";
import { getMonths, getUserRole } from "../redux/selectors";
import { getPeriod } from "../redux/actions";
import { ColumnsType } from "antd/es/table/interface";
import locale from "rc-pagination/lib/locale/ru_RU";
import PayerTable from "../components/payer-table";
import TextArea from "antd/es/input/TextArea";

const ReportPage = () => {
  const [isColumnsModalVisible, setIsColumnsModalVisible] = useState(false);
  const [isReasonModalVisible, setIsReasonModalVisible] = useState(false);
  const [sendModalVisible, setSendModalVisible] = useState(false);
  const [allKeys, setAllKeys] = useState<any>([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [current, setCurrent] = useState<any>();
  const [api, contextHolder] = notification.useNotification();
  const [reason, setReason] = useState("");
  const [results, setResults] = useState<any>({});
  const [reasonComment, setReasonComment] = useState("");
  const [comment, setComment] = useState("");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [correctId, setCorrectId] = useState(0);
  const [page, setPage] = useState(1);
  const [tab, setTab] = useState("1");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const getPeriods = useAppSelector(getMonths);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [obj, setObj] = useState<number | null>();
  const [loading, setLoading] = useState(true);
  const antIcon = <LoadingOutlined style={{ fontSize: 5 }} spin />;
  const [optionsCategory, setOptionsCategory] = useState<any>();
  const [options, setOptions] = useState<any>();
  const [categoryNumbers, setCategoryNumbers] = useState<any>();
  const deadline = new Date(current?.deadline);
  const dateNow = new Date();
  const [canChange, setCanChange] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const userRole = useAppSelector(getUserRole);
  const [id, setId] = useState<number | null>(
    +window.location.pathname.split("/")[2]
  );
  const urlReport = window.location.pathname.split("/")[2];

  useEffect(() => {
    setId(+window.location.pathname.split("/")[2]);
  }, [urlReport]);

  useEffect(() => {
    getOptionsCategory();
    getReasonOptions();
    getCoorectReports();
    setTab("1");
  }, [current, id, urlReport]);

  useEffect(() => {
    getOptions(page, search);
  }, [page, search, id, urlReport]);

  useEffect(() => {
    updateData();
    getErrorTypes(current?.error_type);
    deadline?.setDate(6);
    deadline?.setHours(0);
    setCanChange(
      new Date(current?.deadline.slice(0, 7) + "-06T00:00:00") > new Date()
    );

    setCanSubmit(
      dateNow?.getFullYear() == deadline?.getFullYear()
        ? deadline?.getMonth() <= dateNow?.getMonth()
        : dateNow?.getFullYear() > deadline?.getFullYear()
        ? true
        : false
    );
  }, [current, urlReport]);

  useEffect(() => {
    dispatch(getPeriod());
  }, []);

  const getCoorectReports = (): void => {
    //setLoading(true);
    guestsService
      .getReports(1, "", "", `parent=${id}`, "correcting")
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          console.log("RESP", resp);
          setCorrectCount(resp.count);
          if (resp.results.length > 0) setCorrectId(resp.results[0].id);
          updateData();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //const id = window.location.pathname.split("/")[2];

  const getErrorTypes = (id: any) => {
    guestsService
      .getErrorReport()
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          console.log(
            "comment",
            resp?.results?.find((it: any) => it.id == +id)
          );
          setComment(resp?.results?.find((it: any) => it.id == +id)?.name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOptions = (page: number, search: string): void => {
    setPage(page);
    setLoading(true);
    guestsService
      .getReport(id)
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          setCurrent(resp);
          setLoading(false);
          updateData();
          setReason(resp.object_status);
          setReasonComment(resp.object_status_comment);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getReasonOptions = (): void => {
    guestsService
      .getReportReasons()
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          let results: any = [];

          for (let [key, value] of Object.entries(resp)) {
            results.push({
              value: key,
              label: value,
            });
          }
          setOptions(results);
          setResults(resp);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsColumnsModalVisible(false);
    setIsReasonModalVisible(false);
    setSendModalVisible(false);
    setObj(null);
  };

  const updateData = () => {
    console.log("columns", defaultColumns);
    const allKey = defaultColumns?.map((it) => it?.title);
    console.log("data", data);

    setAllKeys(allKey);
  };

  const updateChecked = (value: any) => {
    setCheckedKeys(value);
  };

  const viewObj = (obj: any) => {
    console.log(obj);
    navigate(`/moder-organizations/${obj.pk}`);
  };

  const error = (err: any) => {
    for (let key in err) {
      api.open({
        type: "error",
        message: "Ошибка!",
        description: key + " " + err[key],
      });
    }
  };

  const getOptionsCategory = (): void => {
    guestsService
      .getNumberCategory()
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          let categories: any = Object.keys(resp);

          setOptionsCategory(categories);
          let catNum = Object.values(resp);
          setCategoryNumbers(catNum);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const calcSumm = (obj: []) => {
    if (obj) return Object.values(obj).reduce((a: any, b: any) => a + b, 0);
    else return 0;
  };

  const data: any = [];
  data.push({
    key: current?.pk,
    title:
      current?.organization?.address +
      " (" +
      current?.organization?.brand_name +
      ")",
    total_guests: current?.total_guests,
    total_resort_fee: current?.total_resort_fee,
    guests_count: current?.total_guests,
    operating_period: current?.organization?.operating_period?.map(
      (item: string | number) => getPeriods[item] + " "
    ),
    privileged_guests_count: calcSumm(current?.benefit_category_counts),
    number_of_refusals: current?.number_of_refusals,
    fee_payers:
      current?.fee_payers -
        current?.number_of_refusals -
        calcSumm(current?.benefit_category_counts) >
      0
        ? current?.fee_payers -
          current?.number_of_refusals -
          calcSumm(current?.benefit_category_counts)
        : 0,
    benefit_category_counts: current?.benefit_category_counts,
    inn: current?.inn,
    organization_name: current?.organization_name,
    non_fee_payers: current?.non_fee_payers,
  });

  const columns: ColumnsType<any> = [
    {
      title: "ИНН",
      dataIndex: "inn",
      key: "inn",
    },
    {
      title: "Оператор",
      dataIndex: "organization_name",
      key: "organization_name",
    },
    {
      title: "Объект размещения",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Период",
      dataIndex: "operating_period",
      key: "operating_period",
    },
    {
      title: "Размещенных лиц (кол-во)",
      dataIndex: "total_guests",
      key: "total_guests",
    },
    {
      title: "Уплативших КС (кол-во)",
      dataIndex: "fee_payers",
      key: "fee_payers",
    },
    {
      title: "Сумма перечисленных средств",
      dataIndex: "total_resort_fee",
      key: "total_resort_fee",
    },
    {
      title: "Реквизиты платежа",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Отказавшихся от уплаты (кол-во)",
      dataIndex: "number_of_refusals",
      key: "number_of_refusals",
      width: 100,
    },
  ];

  for (let i = 0; i < optionsCategory?.length; i++) {
    if (current?.benefit_category_counts[optionsCategory[i]] > 0) {
      Object.assign(data[0], {
        [optionsCategory[i]]:
          current?.benefit_category_counts[optionsCategory[i]],
      });
      columns.push({
        title: categoryNumbers?.length > 0 && categoryNumbers[i],
        dataIndex: optionsCategory?.length > 0 && optionsCategory[i],
        key: optionsCategory?.length > 0 && optionsCategory[i],
        width: 100,
      });
    }
  }

  columns.push(
    {
      title: "Всего лиц с льготой (кол-во)",
      dataIndex: "privileged_guests_count",
      key: "privileged_guests_count",
      width: 100,
    },
    {
      title: "Не относящихся к категории плательщиков (кол-во)",
      dataIndex: "non_fee_payers",
      key: "non_fee_payers",
      width: 100,
    }
  );

  const filterColumns = checkedKeys?.map((key: React.Key | undefined) => {
    return columns?.filter((it) => it?.title == key)[0];
  });

  let defaultColumns = columns;

  const onChange = (key: string) => {
    setTab(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Отчет",
    },
    {
      key: "2",
      label: "Плательщики",
    },
  ];

  const backDraftRep = (id: any) => {
    guestsService
      .createCorrectingRep(id.toString())
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          api.open({
            type: "success",
            message: "Успешно",
            description: "Создан корректирующий отчет",
          });
          console.log(resp);
          getOptions(page, search);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const returnRep = (id: any) => {
    guestsService
      .returnReport(id.toString())
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          api.open({
            type: "success",
            message: "Успешно",
            description: "Отчет снова доступен для редактирования",
          });
          console.log(resp);
          getOptions(page, search);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkRep = (): void => {
    if (current?.total_guests == 0) setIsReasonModalVisible(true);
    else setSendModalVisible(true);
    //else approveRep()
  };

  const params =
    reason == "other" && current?.total_guests == 0
      ? {
          object_status: reason,
          object_status_comment: reasonComment,
        }
      : reason != "other" && current?.total_guests == 0
      ? {
          object_status: reason,
        }
      : {};

  const approveRep = (id: any): void => {
    guestsService
      .approveReport(id, params)
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          api.open({
            type: "success",
            message: "Успешно",
            description: "Отчет подтвержден и отправлен",
          });
          getOptions(page, search);
          console.log(resp);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    handleCancel();
  };

  return (
    <div className="flex flex-start">
      {contextHolder}
      <LeftMenu />
      <TopMenu />

      {loading ? (
        <div className="page-loading">
          <Spin indicator={antIcon} />
        </div>
      ) : (
        <div className="box">
          <div className="header">
            {" "}
            <Breadcrumb
              items={[
                {
                  title: "Главная страница",
                },
                {
                  title: "Отчеты ОКС",
                },
                {
                  title: `Отчет ОКС (${current?.date?.slice(0, 7)})`,
                },
              ]}
            />
            <h3>
              {current?.object_type
                ? current?.object_type == "correcting"
                  ? "Корректирующий"
                  : "Первичный"
                : ""}{" "}
              отчет оператора курортного сбора ({current?.date?.slice(0, 7)})
            </h3>
          </div>
          <div>
            {current?.status == "need_revision" &&
              current?.error_type == null && (
                <Alert
                  //message="Warning"
                  description={
                    "Отчет отправлен на доработку с комментарием: " +
                    current?.comment
                  }
                  type="warning"
                  showIcon
                />
              )}
            {current?.error_type != null && (
              <Alert
                message={comment}
                description={
                  "Отчет отклонен с комментарием: " + current?.comment
                }
                type="error"
                showIcon
              />
            )}
            {current?.object_status != " " &&
              current?.total_guests == 0 &&
              current?.status != "draft" && (
                <Alert
                  description={
                    "Пустой отчет отправлен " +
                    (results[current?.object_status]
                      ? "по причине: " + results[current?.object_status]
                      : "") +
                    (current?.object_status_comment != " " &&
                    current?.object_status == "other"
                      ? " с комментарием: " + current?.object_status_comment
                      : " ")
                  }
                  type="info"
                  showIcon
                />
              )}
          </div>
          <div className="header">
            <div className="flex flex-space">
              <Tabs items={items} onChange={onChange} />
              <div className="flex">
                {correctCount == 0 && current?.parent != null && (
                  <Button
                    className="btn"
                    onClick={() => {
                      navigate(`/report/${current?.parent}`);
                      setId(current?.parent);
                    }}
                  >
                    Перейти к первичному отчету
                  </Button>
                )}

                {userRole == "operator" ? (
                  current?.object_type == "correcting" &&
                  current?.status != "draft" &&
                  canChange ? (
                    <Button
                      className="btn"
                      type={"primary"}
                      onClick={() => returnRep(id)}
                      disabled={!canSubmit}
                    >
                      Вернуться к редактированию
                    </Button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {userRole == "operator" ? (
                  (current?.status == "draft" && current?.error_type == null) ||
                  (current?.object_type == "correcting" &&
                    current?.status == "need_revision" &&
                    current?.error_type == null) ? (
                    <Button
                      className="btn"
                      type={"primary"}
                      onClick={() => checkRep()}
                      disabled={!canSubmit}
                    >
                      Подтвердить и отправить
                    </Button>
                  ) : (current?.object_type != "correcting" &&
                      current?.status != "draft" &&
                      canChange &&
                      correctCount == 0) ||
                    (current?.object_type != "correcting" &&
                      current?.status == "need_revision" &&
                      current?.error_type == null &&
                      correctCount == 0) ? (
                    <Button
                      disabled={correctCount > 0}
                      className="btn"
                      onClick={() => backDraftRep(id)}
                    >
                      Создать корректирующий отчет
                    </Button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {correctCount > 0 && (
                  <Button
                    className="btn"
                    onClick={() => {
                      navigate(`/report/${correctId}`);
                      setId(correctId);
                    }}
                  >
                    Перейти к корректирующему отчету
                  </Button>
                )}
              </div>
            </div>
          </div>
          {tab == "1" && (
            <div>
              <div className="flex flex-space">
                <div className="flex">
                  {/*current?.organization?.admins?.length > 0 &&
                    current?.approved_by_admin_date == null && (
                      <Tooltip
                        placement="top"
                        title={
                          "Исполнитель не подтвердил список плательщиков за отчетный период"
                        }
                        color="blue"
                      >
                        <WarningOutlined />
                      </Tooltip>
                      )*/}
                  {current?.organization?.address +
                    " (" +
                    current?.organization?.brand_name +
                    ")"}
                </div>
                <Button
                  className="btn"
                  onClick={() => setIsColumnsModalVisible(true)}
                >
                  {" "}
                  <SettingOutlined />
                  Настройка колонок
                </Button>
              </div>
              <Table
                columns={
                  filterColumns?.length > 0 ? filterColumns : defaultColumns
                }
                //rowSelection={{ selectedRowKeys: [] }}
                scroll={{ x: 1000 }}
                dataSource={data}
                //onChange={onChange}
                pagination={{
                  locale: locale,
                  pageSize: 10,
                  total: count,
                  current: page,
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                  onChange: (value) => setPage(value),
                }}
                showSorterTooltip={false}
              />
            </div>
          )}
          {tab == "2" && (
            <PayerTable
              hotel={current?.organization?.id}
              month={current?.date.slice(0, 7)}
              current={current}
            />
          )}
        </div>
      )}
      <ColumnsModal
        isModalVisible={isColumnsModalVisible}
        handleCancel={handleCancel}
        allKeys={allKeys}
        updateChecked={updateChecked}
      />
      <Modal
        title={`По объекту размещения пустой отчет (нет гостей). Вы уверены, что хотите отправить отчет?`}
        open={isReasonModalVisible}
        onCancel={handleCancel}
        cancelText="Отменить"
        okText="Отправить"
        footer={null}
        maskClosable={false}
      >
        <div className="modal-input-item flex">
          <div className="tab-label">
            Причина<span className="red">*</span>:
          </div>
          <Select
            placeholder="Выберите причину"
            onChange={(evt) => setReason(evt)}
            value={reason}
            options={options}
            style={{ width: 400 }}
          />
        </div>
        {reason == "other" && (
          <div className="modal-input-item flex">
            <div className="tab-label">
              Комментарий<span className="red">*</span>:
            </div>
            <TextArea
              style={{ width: 400 }}
              rows={3}
              value={reasonComment}
              onChange={(evt) => setReasonComment(evt.target.value)}
            />
          </div>
        )}
        <p></p>
        <div className="flex flex-space">
          <Button onClick={() => handleCancel()}>Отменить</Button>
          <Button type="primary" onClick={() => approveRep(id)}>
            Отправить
          </Button>
        </div>
      </Modal>
      <Modal
        title={`Проверьте корректность и полноту данных, внесенных в отчет, перед отправкой`}
        open={sendModalVisible}
        onCancel={handleCancel}
        onOk={() => approveRep(id)}
        cancelText="Отменить"
        okText="Отправить"
        //footer={null}
        maskClosable={false}
      ></Modal>
    </div>
  );
};
export default ReportPage;
